import styled from 'styled-components';

export const ModalWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper};
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
  font-size: 18px;

  * {
    box-sizing: border-box;
  }
`;

export const Heading = styled.div`
  padding: 0 11px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FilterBy = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  h2 {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: -0.3px;
  }

  img {
    width: 30px;
    height: 30px;
    padding-right: 10px;
  }
`;

export const FilterClear = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.secondary};
  .section-link {
    padding-right: 10px;
  }

  &:hover {
    .section-link {
      color: ${({ theme }) => theme.palette.info.main};
    }

    img {
      transform: rotate(-90deg);
    }
  }

  img {
    transform: rotate(0);
    transition: transform 0.1s ease-out 0s;
  }
`;

export const FilterOptions = styled.div`
  max-height: 50vh;
  overflow-y: auto;
`;

export const Section = styled.div`
  padding: 5px 10px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SectionTitle = styled.div`
  font-size: 14px;
  padding-bottom: 6px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SectionCheckbox = styled.div`
  min-width: 20px;
`;

export const SectionItem = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  padding: 2px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    margin: 0;
    font-size: 18px;
  }
`;
